<div>
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <button mat-button (click)="onRefresh()">
        <mat-icon aria-hidden="false" aria-label="Refresh">refresh</mat-icon>
        Refresh Projects
      </button>
      <button mat-button (click)="onAdd()">
        <mat-icon aria-hidden="false" aria-label="Add Project">add</mat-icon>
        Add Project
      </button>
      <span class="toolbar-spacer"></span>
      <mat-form-field color="accent">
        <input matInput placeholder="Search projects..." [(ngModel)]="filter" (ngModelChange)="onFilter($event)" />
      </mat-form-field>
      <button mat-icon-button aria-label="Clear" *ngIf="filter" (click)="onFilter('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <ng-container *ngIf="loading; else loaded">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading Projects...</p>
    </div>
  </ng-container>
  <ng-template #loaded>
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      matSort
      matSortActive="name"
      matSortDirection="asc"
      width="100%"
    >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project ID</th>
        <td mat-cell *matCellDef="let item">{{ item.id }}</td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let item">{{ item.name }}</td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>External ID</th>
        <td mat-cell *matCellDef="let item">{{ item.externalId }}</td>
      </ng-container>
      <ng-container matColumnDef="divisionType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Division</th>
        <td mat-cell *matCellDef="let item">{{ item.divisionType }}</td>
      </ng-container>
      <ng-container matColumnDef="completionType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Completion System</th>
        <td mat-cell *matCellDef="let item">{{ item.completionType }}</td>
      </ng-container>
      <ng-container matColumnDef="jobFeedbackRecipientEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job-card feedback recipient email</th>
        <td mat-cell *matCellDef="let item">{{ item.jobFeedbackRecipientEmail || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="weightChangeRecipientEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Weight-change report recipient email</th>
        <td mat-cell *matCellDef="let item">{{ item.weightChangeRecipientEmail || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-flat-button color="accent" [routerLink]="['/admin/projects', item.id]">Edit</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </ng-template>
</div>
